const setLoadingState = ({ commit }, isLoading) => {
  commit('SET_LOADING_STATE', isLoading)
}

export default {
  setLoadingState
}
